export default class Aba {
  constructor(tipo, show, data) {
    this.tipo = tipo;
    this.show = show;
    this.data = data;
  }
}
